import { Col, Image, Row, Typography } from "antd";

interface Props {
  title: any;
  image: any;
  icon: any;
  subHeading1?: any;
  subHeading2?: any;
  description1?: any;
  description2?: any;
  bottomText: any;
  class?: any;
  id?: any;
}

const ServiceList = (props: Props) => {
  return (
    <div className={`services-lists ${props.class}`} id={props?.id}>
      <Row>
        <Col className="service-list-left" sm={24} xl={11}>
          <Image data-aos="fade-up" preview={false} src={props.image} />
        </Col>
        <Col className="service-list-right" sm={24} xl={13}>
          <div className="service-list-header rohit">
            {props.icon}
            <Typography.Title level={4}>{props.title}</Typography.Title>
          </div>
          <div className="service-list-content">
            {props.subHeading1 && (
              <Typography.Title level={5}>{props.subHeading1}</Typography.Title>
            )}{" "}
            <Typography.Text>{props.description1}</Typography.Text>
            {props.subHeading2 && (
              <Typography.Title level={5}>{props.subHeading2}</Typography.Title>
            )}
            {props.description2 && (
              <Typography.Text className="last">
                {props.description2}
              </Typography.Text>
            )}{" "}
          </div>
        </Col>
      </Row>
      {props.bottomText && (
        <Typography.Text className="service-text-bottom">
          {props.bottomText}
        </Typography.Text>
      )}
    </div>
  );
};

export default ServiceList;
